import type { RouteObject } from 'react-router-dom';
import Spinner from '~/components/Spinner';
import { catchallRoute } from '~/utils/routing';
import CrewLookup from './[:store]';
import ErrorPage from './error';
import {
  action as editAddressAction,
  loader as editAddressLoader,
} from './features/address/edit/editAddress';
import EditAddressPage from './features/address/edit/EditAddressPage';
import { loader as addressReviewLoader } from './features/address/review/addressReview';
import AddressReviewPage from './features/address/review/AddressReviewPage';
import { loader as appShellLoader } from './features/app-shell/appShell';
import AppShellLayout from './features/app-shell/AppShellLayout';
import { orderLookupAction } from './features/order-lookup/orderLookup';
import { BasicOrderLookupPage } from './features/order-lookup/OrderLookupPage';
import { middleware as protectionOrderMiddleware } from './features/protection-order/middleware';
import ProtectionOrderNotProtectedPage from './features/protection-order/not-protected/ProtectionOrderNotProtectedPage';
import { loader as protectionOrderOverviewLoader } from './features/protection-order/overview/protectionOrderOverview';
import ProtectionOrderOverviewPage from './features/protection-order/overview/ProtectionOrderOverviewPage';
import { loader as shippingProtectionClaimOverviewLoader } from './features/shipping-claim/claim-overview/shippingClaimOverview';
import ShippingProtectionClaimOverviewPage from './features/shipping-claim/claim-overview/ShippingClaimOverviewPage';
import {
  action as shippingClaimItemsAction,
  loader as shippingClaimItemsLoader,
} from './features/shipping-claim/new-claim/items/shippingClaimItems';
import ShippingClaimItemsPage from './features/shipping-claim/new-claim/items/ShippingClaimItemsPage';
import {
  action as shippingClaimMetaAction,
  loader as shippingClaimMetaLoader,
} from './features/shipping-claim/new-claim/meta/shippingClaimMeta';
import ShippingClaimMetaPage from './features/shipping-claim/new-claim/meta/ShippingClaimMetaPage';
import {
  action as shippingClaimReasonAction,
  loader as shippingClaimReasonLoader,
} from './features/shipping-claim/new-claim/reason/shippingClaimReason';
import ShippingClaimReasonPage from './features/shipping-claim/new-claim/reason/ShippingClaimReasonPage';
import {
  action as shippingClaimReviewAction,
  loader as shippingClaimReviewLoader,
} from './features/shipping-claim/new-claim/review/shippingClaimReview';
import ShippingClaimReviewPage from './features/shipping-claim/new-claim/review/ShippingClaimReviewPage';
import { loader as shippingIssueLoader } from './features/shipping-claim/new-claim/shipping-issue/shippingIssue';
import ShippingIssuePage from './features/shipping-claim/new-claim/shipping-issue/ShippingIssuePage';
import { middleware } from './middleware';

export default {
  id: 'appShell',
  HydrateFallback: Spinner,
  handle: {
    middleware,
  },
  loader: appShellLoader,
  ErrorBoundary: ErrorPage,
  Component: AppShellLayout,
  children: [
    {
      id: 'orderLookup',
      index: true,
      action: orderLookupAction,
      Component: BasicOrderLookupPage,
    },
    CrewLookup,
    {
      path: '/:store?/reorder/:idFromPlatform',
      handle: {
        middleware: protectionOrderMiddleware,
      },
      children: [
        {
          index: true,
          Component: ProtectionOrderOverviewPage,
          loader: protectionOrderOverviewLoader,
        },
        {
          id: 'protectionOrderNotProtected',
          path: 'not-protected',
          Component: ProtectionOrderNotProtectedPage,
        },
        {
          id: 'shippingProtectionClaimOverview',
          path: 'claim/:claimId/:entryPoint?',
          Component: ShippingProtectionClaimOverviewPage,
          loader: shippingProtectionClaimOverviewLoader,
        },
        {
          path: 'new',
          children: [
            {
              id: 'shippingClaimReason',
              index: true,
              Component: ShippingClaimReasonPage,
              loader: shippingClaimReasonLoader,
              action: shippingClaimReasonAction,
            },
            {
              id: 'shippingIssue',
              path: 'shipping-issue',
              Component: ShippingIssuePage,
              loader: shippingIssueLoader,
            },
            {
              id: 'shippingClaimItems',
              path: 'items',
              Component: ShippingClaimItemsPage,
              loader: shippingClaimItemsLoader,
              action: shippingClaimItemsAction,
            },
            {
              id: 'shippingClaimMeta',
              path: 'meta',
              Component: ShippingClaimMetaPage,
              loader: shippingClaimMetaLoader,
              action: shippingClaimMetaAction,
            },
            {
              id: 'shippingClaimAddressReview',
              path: 'address',
              Component: AddressReviewPage,
              loader: addressReviewLoader,
            },
            {
              id: 'shippingClaimAddressEdit',
              path: 'address/edit',
              Component: EditAddressPage,
              action: editAddressAction,
              loader: editAddressLoader,
            },
            {
              path: 'review',
              Component: ShippingClaimReviewPage,
              loader: shippingClaimReviewLoader,
              action: shippingClaimReviewAction,
              // don't want to run loader again with action submit since we are creating a claim and clearing the context
              shouldRevalidate: () => false,
            },
          ],
        },
      ],
    },
    catchallRoute,
  ],
} satisfies RouteObject;
